import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const contractRoutes: CustomRouteRecordRaw = {
  path: 'contract',
  name: 'contract',
  component: EmptyLayout,
  meta: {
    title: '合同管理',
    iconfont: 'icon-account-pin-box-line1',
    requiredPermission: 'contract',
  },
  children: [
    {
      path: 'contract-template-list',
      name: 'contractTemplateList',
      component: () => import('@/views/contract/contract-template-list.vue'),
      meta: {
        title: '合同模板',
        requiredPermission: 'contract.template.list',
      },
    },
    {
      path: 'contract-template-detail',
      name: 'contractTemplateDetail',
      component: () => import('@/views/contract/contract-template-detail.vue'),
      meta: {
        parentName: 'contractTemplateList',
        hideInMenu: true,
        title: '发起合同',
        requiredPermission: 'contract.template.detail',
      },
    },
    {
      path: 'contract-list',
      name: 'contractList',
      component: () => import('@/views/contract/contract-list.vue'),
      meta: {
        title: '合同签署列表',
        requiredPermission: 'contract.sign.list',
      },
    }
  ],
}
